import React from 'react'
import './Item.css';
import {Link} from 'react-router-dom'
const Item = (props) =>{


    return<>

        <div className="item">

            <Link to={`/product/${props.id}`}><img src={props.img} alt="" onClick={window.scrollTo(0,0)}/></Link>
            <p>{props.name}</p>
            <div className="item-price">
                <div className="old-price">${props.new_price}</div>
                <div className="new-price">${props.old_price}</div>
            </div>
        </div>
    </>

}

export default Item